module.exports = __webpack_public_path__ + "assets/img/footer-download.9eed105d.png";